<template>
  <ui-loader class="article-list" :loading="loading" :lang="loaderLang" :completed="completed" :listens="['scroll']" @scroll="scroll" v-if="articleList">
    <card-article v-for="article of articleList" :key="article.id" :article="article"></card-article>
  </ui-loader>
</template>
<script>
import api from "../../api/index";
import CardArticle from "../card/card-article.vue";
export default {
  data() {
    return {
      articleList: [],
      limit: 8,
      loading: false,
      completed: false,
      loaderLang: {
        pullDownToRefresh: this.$t("pullDownToRefresh"),
        releaseToRefresh: this.$t("releaseToRefresh"),
        pullUpToLoad: this.$t("pullUpToLoad"),
        loadCompleted: this.$t("loadCompleted")
      }
    };
  },
  components: {
    CardArticle
  },
  props: {
    from: {
      type: String,
      validator(value) {
        return ["book", "created", "faved", "draft"].includes(value);
      }
      // required: true
    },
    bookId: String,
    eventName: String
  },
  computed: {
    skip() {
      return this.articleList.length;
    }
  },

  mounted() {
    if (!this.articleList.length) {
      this.fetchData();
    }
  },
  methods: {
    scroll() {
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      this.completed = false;

      if (this.from == "book") {
        if (this.bookId) {
          api
            .articleListByBookId(this.bookId, this.limit, this.skip)
            .then(res => {
              this.loading = false;
              if (res.status == 200) {
                this.articleList = this.articleList.concat(res.data.articleList);
              }
              if (res.status == 204) {
                this.completed = true;
              }
            });
        }
        if (this.eventName) {
          api
            .getArticleListByEventName(this.eventName, this.limit, this.skip)
            .then(res => {
              this.loading = false;
              if (res.status == 200) {
                this.articleList = this.articleList.concat(res.data.articleList);
              }
              if (res.status == 204) {
                this.completed = true;
              }
            });
        }
      } else {
        api.getArticleList(this.from, this.limit, this.skip).then(res => {
          this.loading = false;
          if (res.status == 200) {
            this.articleList = this.articleList.concat(res.data.articleList);
          }
          if (res.status == 204) {
            this.completed = true;
          }
        });
      }
    }
  }
};

</script>
